document.addEventListener('DOMContentLoaded', function () {
  console.log('[cartValidation] Initializing all cart functionality...');

  // ===== DEPOSIT PAYMENT HANDLING =====
  let depoInitialized = false;
  let cartObserver = null;

  // Function to check cart items for deposit payments
  function checkCartItems() {
    const cartItems = document.querySelectorAll('.cart-item__details');
    let hasNonZeroDeposit = false;

    cartItems.forEach((item, index) => {
      const options = item.querySelectorAll('.product-option');

      options.forEach((option, optIndex) => {
        if (
          option.textContent.includes('Non-Refundable Deposit:') ||
          option.textContent.includes('Part Payment Amount(per product)')
        ) {
          const amount = option.querySelector('dd').textContent.trim();

          if (amount !== '$0.00') {
            hasNonZeroDeposit = true;
            const productOption = option.closest('.product-option');
            if (productOption) {
              productOption.style.visibility = 'visible';
              const dt = productOption.querySelector('dt');
              if (dt) {
                dt.textContent = 'Non-Refundable Deposit:';
              }
            }
          }
        }
      });
    });
    document.documentElement.style.setProperty(
      '--depo-deposit-amount-visibility',
      hasNonZeroDeposit ? 'visible' : 'hidden'
    );
    return hasNonZeroDeposit;
  }

  // Function to check if customer is using deposit payment
  function isUsingDeposit() {
    const hasDeposit = checkCartItems();

    if (hasDeposit) {
      const depoAmountDue = document.getElementById('depo-amount-due');

      if (depoAmountDue) {
        const depoPrices = depoAmountDue.querySelectorAll('.depo-price');

        if (depoPrices.length > 0) {
          const dueLaterText = depoAmountDue.textContent;

          if (
            dueLaterText.includes('Amount Due Later') ||
            dueLaterText.includes('Due Later')
          ) {
            for (const price of depoPrices) {
              const amount = parseFloat(
                price.textContent.replace(/[^0-9.]/g, '')
              );
              if (!isNaN(amount) && amount > 0) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

  // Function to update deposit text and visibility
  function updateDepositDisplay() {
    const depoAmountDue = document.getElementById('depo-amount-due');
    const depoAmtDueToday = document.getElementById('depo-amt-due-today');

    if (!depoAmountDue || !depoAmtDueToday) {
      return false;
    }

    // Add additional check to ensure element is fully rendered
    if (depoAmountDue.offsetHeight === 0) {
      return false;
    }

    const isDeposit = isUsingDeposit();
    const taxNote = document.querySelector('.js-contents .tax-note');

    if (isDeposit) {
      console.log('[updateDepositDisplay] Processing deposit payment...');
      document.documentElement.style.setProperty(
        '--depo-amount-due-visibility',
        'visible'
      );
      const prices = depoAmountDue.querySelectorAll('.depo-price');
      const depositPrice = prices[0]?.textContent || '$0.00';
      const laterPrice = prices[1]?.textContent || '$0.00';

      depoAmountDue.innerHTML = `
        <div>
          <div class="depo-text-wrapper">
            <div class="depo-label-main">Non-Refundable Deposit</div>
            <div class="depo-label-fees">(incl. Processing Fees):</div>
          </div>
          <div class="depo-price">${depositPrice}</div>
        </div>
        <div>
          <div class="depo-text-wrapper">
            <div class="depo-label-main">Amount Due Later</div>
            <div class="depo-label-fees">(incl. Processing Fees):</div>
          </div>
          <div class="depo-price">${laterPrice}</div>
        </div>
      `;

      if (taxNote) taxNote.style.display = 'none';
    } else {
      depoAmtDueToday.textContent = 'Subtotal';
      const dueLaterElement = Array.from(depoAmountDue.children).find(el =>
        el.textContent.includes('Amount Due Later')
      );
      if (dueLaterElement) dueLaterElement.style.display = 'none';

      document.documentElement.style.setProperty(
        '--depo-amount-due-visibility',
        'visible'
      );
      if (taxNote) taxNote.style.display = 'flex';
    }
    return true;
  }

  // Function to initialize cart observer
  function initializeCartObserver() {
    if (cartObserver) cartObserver.disconnect();

    const cartContainer = document.querySelector('.cart__items');
    if (cartContainer) {
      cartObserver = new MutationObserver(() => {
        if (document.getElementById('depo-amount-due')) {
          updateDepositDisplay();
        }
      });

      cartObserver.observe(cartContainer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }
  }

  // Watch for specific Depo elements to be added
  const depoObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (
              node.id === 'depo-amount-due' ||
              node.querySelector('#depo-amount-due')
            ) {
              console.log(
                '[depoObserver] Found depo-amount-due element, scheduling update...'
              );
              setTimeout(() => {
                const success = updateDepositDisplay();
                if (success && !depoInitialized) {
                  depoInitialized = true;
                  initializeCartObserver();
                }
              }, 100);
            }
          }
        }
      }
    }
  });

  depoObserver.observe(document.body, { childList: true, subtree: true });

  // Also check periodically for a short while
  const maxAttempts = 20;
  let attempts = 0;
  const initializationTimer = setInterval(() => {
    if (depoInitialized || attempts >= maxAttempts) {
      clearInterval(initializationTimer);
      return;
    }
    attempts++;
    updateDepositDisplay();
  }, 500);

  // Try initial check
  updateDepositDisplay();

  // ===== COUPON HANDLING =====
  // Apply Coupon Script
  var savedCode = localStorage.getItem('coupon');
  var discountInput = document.querySelector('input[name="discount"]');
  if (discountInput && savedCode) {
    discountInput.value = savedCode;
  }

  var applyCouponBtn = document.getElementById('apply-coupon');
  if (applyCouponBtn) {
    applyCouponBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var target = '/checkout?discount=';
      var discountValue = discountInput ? discountInput.value : '';
      var checkoutUrl = target + discountValue;
      console.log('Navigating to:', checkoutUrl);
      window.location.href = checkoutUrl;
    });
  }

  // ===== SUBTOTAL UPDATING =====
  function updateSubtotal() {
    const priceElements = document.querySelectorAll(
      '.cart-item__totals.right.small-hide > .cart-item__price-wrapper > span.price.price--end'
    );
    const subtotalElement = document.querySelector(
      '.totals > p.totals__subtotal-value'
    );

    if (!subtotalElement) return;

    const prices = Array.from(priceElements).map(el => {
      const numericValue = parseFloat(el.innerText.replace(/[^\d.]/g, ''));
      return isNaN(numericValue) ? 0 : numericValue;
    });

    const sum = prices.reduce((total, price) => total + price, 0);
    if (!isNaN(sum) && sum !== undefined) {
      subtotalElement.innerText = '$' + sum.toFixed(2);
    }
  }

  // Update subtotal on cart changes instead of polling
  const subtotalObserver = new MutationObserver(() => {
    updateSubtotal();
  });

  const cartContainer = document.querySelector('.cart__items');
  if (cartContainer) {
    subtotalObserver.observe(cartContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Initial update
  updateSubtotal();

  // ===== CHECKOUT VALIDATION =====
  const CHECK_IDS = ['terms-checkbox']; // Only require Terms & Conditions
  let hasAttemptedCheckout = false;

  // Function to validate checkboxes
  function validateCheckboxes() {
    const result = CHECK_IDS.every(id => {
      const checkbox = document.getElementById(id);
      const isChecked = checkbox && checkbox.checked;
      return isChecked;
    });
    return result;
  }

  // Function to show error message
  function showErrorMessage() {
    hasAttemptedCheckout = true;
    const termsCheckbox = document.getElementById('terms-checkbox');
    const termsLabel = termsCheckbox ? termsCheckbox.closest('label') : null;
    const errorMessage = document.getElementById('terms-error-message');

    if (termsLabel) {
      termsLabel.classList.add('warning');
      termsLabel.classList.add('error');
    }
    if (errorMessage) errorMessage.style.display = 'block';
  }

  // Function to hide error message
  function hideErrorMessage() {
    const termsCheckbox = document.getElementById('terms-checkbox');
    const termsLabel = termsCheckbox ? termsCheckbox.closest('label') : null;
    const errorMessage = document.getElementById('terms-error-message');

    if (termsLabel) {
      termsLabel.classList.remove('warning');
      termsLabel.classList.remove('error');
    }
    if (errorMessage) errorMessage.style.display = 'none';
  }

  // Block all checkout navigation attempts
  function blockCheckoutNavigation() {
    try {
      const originalHref =
        Object.getOwnPropertyDescriptor(window.location, 'href') ||
        Object.getOwnPropertyDescriptor(Location.prototype, 'href');

      if (originalHref && originalHref.configurable) {
        Object.defineProperty(window.location, 'href', {
          get: function () {
            return originalHref.get.call(this);
          },
          set: function (url) {
            if (url.includes('/checkout')) {
              if (!validateCheckboxes()) {
                showErrorMessage();
                return;
              } else {
                hideErrorMessage();
              }
            }
            originalHref.set.call(this, url);
          }
        });
      }
    } catch (error) {
      // Silently handle errors
    }

    // Block form submissions to checkout
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        const action = form.action || '';
        const method = form.method || 'get';

        if (
          action.includes('/checkout') ||
          (method.toLowerCase() === 'post' &&
            form.querySelector('input[name="checkout"]'))
        ) {
          if (!validateCheckboxes()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showErrorMessage();
            return false;
          } else {
            hideErrorMessage();
          }
        }
      },
      true
    );
  }

  // Hide real checkout buttons and show dummy button until T&C is accepted
  function manageCheckoutButtonVisibility() {
    const realButtons = document.querySelectorAll('#checkout, #depo-checkout');
    const dummyButton = document.getElementById('dummy-checkout');

    if (realButtons.length === 0) {
      return false;
    }

    // Mark real buttons as processed
    realButtons.forEach(button => {
      if (!button.hasAttribute('data-cart-validation-button')) {
        button.setAttribute('data-cart-validation-button', 'true');
      }
    });

    // Create dummy button if it doesn't exist
    if (!dummyButton) {
      const firstRealButton = realButtons[0];
      const dummy = firstRealButton.cloneNode(true);
      dummy.id = 'dummy-checkout';
      dummy.setAttribute('data-cart-validation-dummy', 'true');
      dummy.textContent = 'CHECKOUT';

      // Add click handler to dummy button
      dummy.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!validateCheckboxes()) {
          showErrorMessage();
        }
      });

      // Insert dummy button after the real button
      firstRealButton.parentNode.insertBefore(
        dummy,
        firstRealButton.nextSibling
      );
    }

    // Show/hide buttons based on T&C status using CSS classes
    const isTermsAccepted = validateCheckboxes();

    // Add cart-validation-ready class to enable CSS transitions
    document.body.classList.add('cart-validation-ready');

    realButtons.forEach(button => {
      if (isTermsAccepted) {
        button.classList.add('terms-accepted');
        button.classList.remove('terms-not-accepted');
        button.classList.remove('disabled');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('tabindex');
      } else {
        button.classList.remove('terms-accepted');
        button.classList.add('terms-not-accepted');
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
      }
    });

    if (dummyButton) {
      if (isTermsAccepted) {
        dummyButton.classList.remove('terms-not-accepted');
        dummyButton.classList.remove('disabled');
        dummyButton.removeAttribute('aria-disabled');
        dummyButton.removeAttribute('tabindex');
      } else {
        dummyButton.classList.add('terms-not-accepted');
        dummyButton.classList.add('disabled');
        dummyButton.setAttribute('aria-disabled', 'true');
        dummyButton.setAttribute('tabindex', '-1');
      }
    }

    return true;
  }

  // Set up checkbox change handlers
  function setupCheckboxHandlers() {
    CHECK_IDS.forEach(id => {
      const checkbox = document.getElementById(id);
      if (checkbox) {
        checkbox.addEventListener('change', function () {
          if (validateCheckboxes()) {
            hideErrorMessage();
          }
          manageCheckoutButtonVisibility();
        });
      }
    });
  }

  // Function to update all processed button states
  function updateAllButtonStates() {
    const processedButtons = document.querySelectorAll(
      '[data-cart-validation-added="true"]'
    );
    processedButtons.forEach(button => {
      if (validateCheckboxes()) {
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
        button.removeAttribute('tabindex');
      } else {
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('tabindex', '-1');
      }
    });
  }

  // Function to check and replace checkout buttons when they become visible
  function checkAndReplaceVisibleButtons() {
    const buttonSelectors = [
      '#checkout',
      '#depo-checkout',
      'button[name="checkout"]',
      'input[name="checkout"]'
    ];

    let foundNewButtons = false;

    buttonSelectors.forEach(selector => {
      const button = document.querySelector(selector);
      if (button && !button.hasAttribute('data-cart-validation-button')) {
        const style = window.getComputedStyle(button);
        const isVisible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0';

        if (isVisible) {
          foundNewButtons = true;
          console.log(
            '[checkAndReplaceVisibleButtons] Found new checkout button:',
            selector
          );
        }
      }
    });

    if (foundNewButtons) {
      manageCheckoutButtonVisibility();
    }
  }

  // Set up visibility watcher
  function setupVisibilityWatcher() {
    let debounceTimer = null;

    const depoObserver = new MutationObserver(function (mutations) {
      // Debounce the callback to prevent excessive calls
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        mutations.forEach(function (mutation) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style'
          ) {
            const target = mutation.target;
            if (target.id === 'depo-amount-due') {
              checkAndReplaceVisibleButtons();
            }
          }
        });
      }, 50);
    });

    const depoAmountDue = document.getElementById('depo-amount-due');
    if (depoAmountDue) {
      depoObserver.observe(depoAmountDue, {
        attributes: true,
        attributeFilter: ['style']
      });
    } else {
      const bodyObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1 && node.id === 'depo-amount-due') {
                depoObserver.observe(node, {
                  attributes: true,
                  attributeFilter: ['style']
                });
                bodyObserver.disconnect();
              }
            });
          }
        });
      });

      bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // Additional observer for checkout buttons
    const checkoutObserver = new MutationObserver(function (mutations) {
      let shouldCheck = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              // Check if the added node is a checkout button or contains one
              if (
                node.id === 'checkout' ||
                node.id === 'depo-checkout' ||
                node.querySelector('#checkout') ||
                node.querySelector('#depo-checkout') ||
                node.querySelector('button[name="checkout"]') ||
                node.querySelector('input[name="checkout"]')
              ) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      if (shouldCheck) {
        setTimeout(() => {
          checkAndReplaceVisibleButtons();
        }, 100);
      }
    });

    checkoutObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize checkout validation
  blockCheckoutNavigation();
  setupCheckboxHandlers();
  setupVisibilityWatcher();

  // Set initial state - buttons should be hidden until validation is ready
  function setInitialState() {
    const realButtons = document.querySelectorAll('#checkout, #depo-checkout');
    realButtons.forEach(button => {
      button.setAttribute('data-cart-validation-button', 'true');
      button.classList.add('terms-not-accepted');
    });
  }

  // Set initial state
  setInitialState();

  // Manage button visibility immediately and more frequently
  manageCheckoutButtonVisibility();

  // Additional immediate button management attempts
  setTimeout(() => {
    manageCheckoutButtonVisibility();
  }, 50);

  setTimeout(() => {
    manageCheckoutButtonVisibility();
  }, 100);

  setTimeout(() => {
    manageCheckoutButtonVisibility();
  }, 500); // Third check for any late-appearing elements

  setTimeout(() => {
    manageCheckoutButtonVisibility();
  }, 1000); // Fourth check for any very late-appearing elements

  // Also check when the page is fully loaded
  window.addEventListener('load', () => {
    setTimeout(() => {
      manageCheckoutButtonVisibility();
    }, 100);
  });

  console.log(
    '[cartValidation] All cart functionality initialized successfully'
  );
});
